<template>
    <div>
        <text-row v-if="purchase.flags.is_first_contract === false" compact :label-cols-lg="4" :label-cols-sm="4" label="Контракт со вторым поставщиком. Причина" :value="purchase.first_contract_status_title" />
        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Объект контракта - наименование закупочной сессии" :value="purchase.purchase_terms.deliverable_group.name" />
        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Номер контракта в системе учета заказчика" :value="purchase.customer_contract_number" />
        <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Цена контракта, руб." :value="purchase.purchase_terms.contract_price" />
        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Статус контракта" :value="purchase.contract.status.title" />
        <fl44-unknown-volume-send-second-proposal-contract v-if="purchase.actions.customer.store_second_proposal_contract" :purchase="purchase" class="atmo-hash-jump-point pb-0" id="second-proposal-contract" @refresh="refresh($event)" />
        <text-row-proposal-specification-table v-model="purchase.supplier_proposal.deliverables" :without-vat="purchase.supplier_proposal.without_vat">
            <template #header>
                <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Спецификация контракта</h5>
            </template>
        </text-row-proposal-specification-table>
        <template v-if="purchase.is_customer && !purchase.purchase_terms.without_limits && purchase.contract.limits && purchase.contract.limits.length > 0">
            <template v-if="isLimitsEdit">
                <limits-editable-table
                    v-model="form.limits"
                    :total-cost="purchase.purchase_terms.contract_price"
                    @validate="limitsValidate"
                    :limit-year="purchase.purchase_terms.purchase_limit_year"
                    :order-type="purchase.purchase_terms.order_type"
                    :is-data-sending="isDataSending"
                    purchase-type="fl44_unknown_volume"
                    :purchase-id="purchase.id">
                    <template #title>
                        <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Измените лимиты</h5>
                    </template>
                    <template #label-hint>
                        Добавьте или измените лимиты. Необходимо полностью распределить цену контракта по соответствующим лимитам.
                    </template>
                    <template #label-total>
                        Цена контракта, руб.:
                    </template>
                    <template #label-variance>
                        Отклонение от цены контракта, руб.:
                    </template>
                </limits-editable-table>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button variant="custom-outline-secondary" class="text-uppercase my-1 mr-2" @click="isLimitsEdit = false">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button variant="custom-green" :disabled="!isLimitsValid" class="text-uppercase my-1" @click="updateLimits">Сохранить</b-button>
                </b-overlay>
            </template>
            <template v-else>
                <limits-table :items="purchase.contract.limits">
                    <template #title>
                        <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Лимиты по КБК</h5>
                    </template>
                </limits-table>
                <b-button v-if="purchase.status.id === 'contract:active' && purchase.contract.supplementary_agreements.length === 0" variant="custom-green" class="text-uppercase my-1" @click="onEditLimitsClick">Изменить лимиты</b-button>
            </template>
        </template>
        <fl44-unknown-volume-contract-files-table :contract="purchase.contract" :download-zip="downloadZip" class="mb-0">
            <template #title>Основной контракт</template>
        </fl44-unknown-volume-contract-files-table>
        <text-row-disagreement-table v-if="purchase.contract.contract_disagreements && purchase.contract.contract_disagreements.length > 0" :disagreements="purchase.contract.contract_disagreements" />
        <text-row-supplier-accounting v-if="purchase.is_customer && purchase.flags.has_contract && purchase.contract.supplier_accounting" v-model="purchase.contract.supplier_accounting">
            <template #title>
                <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Банковские реквизиты поставщика</h5>
            </template>
        </text-row-supplier-accounting>
    </div>
</template>

<script>
import TextRowProposalSpecificationTable from '@/components/proposals/partials/text-row-proposal-specification-table.vue';
import Fl44UnknownVolumeContractFilesTable from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-contract-files-table.vue';
import Fl44UnknownVolumeSendSecondProposalContract from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-send-second-proposal-contract.vue';
import cloneDeep from 'lodash.clonedeep';

export default {
    name: 'fl44-unknown-volume-purchase-contract-info',
    components: { Fl44UnknownVolumeSendSecondProposalContract, Fl44UnknownVolumeContractFilesTable, TextRowProposalSpecificationTable },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLimitsEdit: false,
            isLimitsValid: false,
            isDataSending: false,
            form: {
                limits: []
            }
        }
    },
    methods: {
        downloadZip() {
            this.$api.documents.downloadWithSignatures(this.purchase.contract.contract_file.contract_attachment.id, this.purchase.contract.zip_name);
        },
        refresh(newHash = null) {
            this.$emit('refresh', newHash);
        },
        limitsValidate(value) {
            this.isLimitsValid = !value;
        },
        onEditLimitsClick() {
            this.form.limits = cloneDeep(this.purchase.contract.limits);
            this.isLimitsEdit = true;
        },
        async updateLimits() {
            const form = {};
            form.limits = this.form.limits.map((item) => {
                return {
                    id: item.id,
                    year: item.year,
                    amount_assigned: item.amount_assigned
                };
            });
            this.isDataSending = true;
            this.$api.products.fl44UnknownVolume.contracts
                .updateContractLimits(this.purchase.id, this.purchase.contract.id, form)
                .then((res) => {
                    if(res) {
                        this.isLimitsEdit = false;
                        this.$emit('refresh', null);
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.isDataSending = false;
                });
        }
    }
};
</script>
